<template>
  <div class="library-container">
    <div id="md-library"></div>
    <LibraryModal v-if="active" />
  </div>
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent } from 'vue';
import { mapState } from 'vuex';

const LibraryModal = defineAsyncComponent(() => import('./LibraryModal.vue'));

export default defineComponent({
  name: 'Library',
  components: {
    LibraryModal,
  },
  data: () => ({}),
  computed: {
    ...mapState('library', {
      active: (state) => (state as any).active,
    }),
  },
  watch: {},
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.gf-btn {
  font-family: $fontFamily;
  font-size: 13px;
  font-weight: 600;
  line-height: 21px;
  width: 92px;
  margin: 4px 5px;
  padding: 5px 0;
  transition: all 0.2s;
  color: white;
  border-radius: 5px;
  outline: none;
  border: none;
  position: relative;
  justify-content: center;
  svg {
    margin-left: 2px;
  }
  svg path {
    fill: #fff;
  }

  &--primary {
    border-color: transparent;
    background: $primary;
    &:hover {
      background: $secondary_1;
    }
  }
  &:before {
    content: '';
    position: absolute;
    display: block;
    bottom: 0;
    left: 0px;
    height: 100%;
    width: 0%;
    background: rgba(255, 255, 255, 0.4);
    transition: width 0.5s ease;
  }

  &--loading {
    &:before {
      transition-duration: 2s;
      width: 75%;
    }
  }
  &--done {
    &:before {
      transition-duration: 0.4s;
      width: 100%;
    }
  }
}
@keyframes item-just-created {
  from {
    background: rgba($eTool, 0.5);
  }
}

#disabled-insert-btn {
  opacity: 0.4;
  @include cursor-not-allowed;
}
</style>
